export default function getInfoAfterLastColon(string) {
    return string.substring(string.lastIndexOf(':') + 1);
}
